import { gql } from '@apollo/client';

// The signed-in agent's most recent Dialpad campaign screenpop (last 30 min), null when none.
// Used to prefill affinity + lead source when the quote form opens without them in its URL.
export const GET_ACTIVE_SCREEN_POP = gql`
  query getActiveScreenPop {
    getActiveScreenPop {
      affinity
      leadSource
      callerPhone
      callId
    }
  }
`;
